

// Third party libraries
import { Form, Row, InputGroup, Col, Table, Spinner, Button, Badge } from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment/moment";
import "./index.css";
import _ from "lodash";

// components
import { errorSwal, successDeleteSwal } from "../../../helper/sweetalert";
import AnimationLoading from "../../../components/Animationloading";
import PaginationHelper from "../../../components/PaginationHelper";
import { convertCurrency, convertOrderStatus, covertTimeZone, numberFormat } from "../../../helper";
import EmptyComponent from "../../../components/EmptyComponent";
import CustomButton from "../../../components/CustomButton";
import ComfirmModal from "../../../components/ComfirmModal";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { LINEAR_GRADIENT_BG } from "../../../const";
import CurrentDateComponents from "../../../components/CurrentDateComponents";
import { DELETE_ORDERGROUP } from "../../../apollo/ordergroup/mutation";
import { GET_ORDER_GROUPS_V2 } from "../../../apollo/ordergroup/query";
import { GET_USER_TYPE } from "../../../apollo/userType/mutation";

// Icons
import { BsFillCheckCircleFill } from "react-icons/bs";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { MdOutlineDateRange, MdOutlineMoneyOff } from "react-icons/md";
import { ImCancelCircle } from "react-icons/im";
import { GET_CATEGORYS } from "../../../apollo/category/query";
import useWindowDimensions from "../../../helper/windowDimensions";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function SaleHistoryDetailList() {
  const history = useHistory();

  //========================================================== 
  const [ordergroup, setOrderGroup] = useState();
  const [ordergroupToltal, setOrderGroupTotal] = useState();
  //========================================================== 

  const { rolePermissions } = useSelector((state) => state.permissions);
  const { height, width } = useWindowDimensions()
  const { t } = useTranslation()

  const [searchText, setSearchText] = useState("");
  const [payment, setPayment] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [filter, setFilter] = useState({
    createdAt_gte: '',
    createdAt_lt: '',
  });
  //? user type useState
  const [newUserTypeData, setNewUserTypeData] = useState();
  const [selectUserType, setSelectUserType] = useState("");
  //? Category useState
  const [newCategoryData, setNewCategoryData] = useState();
  const [isCategory, setIsCategory] = useState("");
  const [isCategoryName, setIsCategoryName] = useState("");

  // ============== > UseLazyQuery And UseMutaion <==============
  const [getOrders, { data: orderGroupsData, loading: loadingSaleOrder }] = useLazyQuery(
    GET_ORDER_GROUPS_V2,
    { fetchPolicy: "cache-and-network" }
  );
  const [userTypeData, { data: getUserTypeData, loading: getUserTypeLoading }] =
    useLazyQuery(GET_USER_TYPE, { fetchPolicy: "cache-and-network" });

  const [getCategories, { data: getCategoryData, loading: getCategoryLoading }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" }
  );

  // ============== > UseLazyQuery And UseMutaion <==============

  const [deleteordergroup, { loading: deleteloading }] =
    useMutation(DELETE_ORDERGROUP);

  // ============== > useEffect <==============

  useEffect(() => {
    if (orderGroupsData) {
      setOrderGroup(orderGroupsData?.orderGroupsV2?.data);
      setOrderGroupTotal(orderGroupsData?.orderGroupsV2?.total);
    }
  }, [orderGroupsData]);

  useEffect(() => {
    fetchSaleHistoryData();
    getCategory();
    userTypeData();
  }, []);

  useEffect(() => {
    const categories = getCategoryData?.categories?.data;
    if (categories) {
      const result = [...categories].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setNewCategoryData(result);
    }
  }, [getCategoryData]);

  useEffect(() => {
    fetchSaleHistoryData();
  }, [
    searchText,
    filter,
    payment,
    _skip,
    isCategory,
    selectUserType,
    selectStatus
  ]);

  //? user type useEffect
  useEffect(() => {
    if (getUserTypeData?.getUserTypes) {
      const data = getUserTypeData?.getUserTypes.filter((item) => item?.isOpen);
      setNewUserTypeData(data);
    }
  }, [getUserTypeData?.getUserTypes]);

  //======================useEffect==========================================

  // ============== > fuctions <==============

  const fetchSaleHistoryData = async () => {
    const controller = new AbortController(); // Create an AbortController
    const signal = controller.signal; // Get the signal

    try {
      if (loadingSaleOrder) return;
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      let _where = {
        shop: shopId,
        isDeleted: false,
        type: "POS",
      };

      if (selectStatus === "") {
        _where = { ..._where, statusNin: ["INDEBTED"] };
      } else {
        _where = { ..._where, status: selectStatus };
      }

      // Check if search text is not empty
      if (searchText !== "") {
        _where = {
          ..._where,
          searchKeyWord: searchText,
        };
      }

      // Filter category
      if (isCategory !== "") {
        _where = {
          ..._where,
          category: isCategory,
          categoryName: isCategoryName,
        };
      }

      // Filter category
      if (payment !== "") {
        _where = {
          ..._where,
          payment: payment,
        };
      }

      if (selectUserType !== "") { _where = { ..._where, userType: selectUserType } };

      // Check if filter date is set
      if (filter?.createdAt_gte && filter?.createdAt_lt) {
        _where = {
          ..._where,
          createdAt_gte: moment(filter?.createdAt_gte).format("YYYY-MM-DD"),
          createdAt_lt: moment(filter.createdAt_lt)
            .add(1, "days")
            .format("YYYY-MM-DD"),
        };
      } else {
        // default this month
        _where = {
          ..._where,
          createdAt_gte: moment().startOf("month").format("YYYY-MM-DD"),
          createdAt_lt: moment().endOf("month").format("YYYY-MM-DD")
        };
      }

      // Fetch the order groups
      await getOrders({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
        },
        context: { fetchOptions: { signal } }, // Pass the signal to the request
      });

    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted:", error);
      } else {
        console.log("Error:", error);
      }
    } finally {
      controller.abort(); // Abort the request if needed
    }
  };

  //? Category call API
  const getCategory = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const response = await getCategories({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });

      const categories = response?.data?.categories?.data;
      if (!_.isEmpty(categories)) {
        const result = [...categories].sort((a, b) =>
          a?.name?.localeCompare(b?.name)
        );
        setNewCategoryData(result);
      }

    } catch (error) {
      console.log("Error:", error);
    }
  };
  //========TODO: Get all order groups============ 

  const handleShowDelete = (id, code) => {
    setDelete({ id, code });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (deleteloading) return;
      await deleteordergroup({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      fetchSaleHistoryData();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal(err);
    }
  };

  const handleCheck = (data) => {
    history.push("/order_detail", {
      state: data,
    })
  }

  return (
    <React.Fragment>
      <div>
        <BreadCrumbComponent
          // goback={() => history.goBack()}
          // txtFirst="ປະຫວັດການຂາຍ"
          txtSecond={`ຂໍ້ມູນການຂາຍ`}
        />
        <div style={{ padding: width > 700 ? "1em 2em" : 3 }}>
          <h4>
            <b>{t("sale_history_title")}</b>
          </h4>
          <p>{t("history_description")}</p>
        </div>

        <div style={{ margin: width > 700 ? ".3em 2em" : 3 }}>
          <Row>
            <Col sm>
              <Form.Label htmlFor="basic-url">{t("search_product_name")}</Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon3">
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                  id="basic-url"
                  placeholder="....."
                  aria-describedby="basic-addon3"
                />
              </InputGroup>
            </Col>

            <Col>
              <Form.Label>{t("category_name_tb")}</Form.Label>
              {(_.isEmpty(newCategoryData) || getCategoryLoading) ? (<p>Category loading...</p>) : (
                <Form.Select
                  name="category"
                  onChange={(e) => {
                    const selectedOption = e?.target?.options[e?.target?.selectedIndex];
                    console.log("value", e?.target?.value);
                    console.log("text", selectedOption?.text);
                    setIsCategory(e?.target?.value);
                    setIsCategoryName(selectedOption?.text);
                  }}
                  value={isCategory}
                  size="md">
                  <option value="">
                    --ເລືອກ--
                  </option>
                  {newCategoryData.map((item, index) => (
                    <option key={index} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Col>

            <Col>
              <Form.Label>{t("customer_type")}</Form.Label>
                <Form.Select
                  name="userType"
                  onChange={(e) => setSelectUserType(e.target.value)}
                  value={selectUserType}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                  }}
                  aria-label="Default select example">
                  <option value="">
                    --{t("select_option")}--
                  </option>
                  {!_.isEmpty(newUserTypeData) && newUserTypeData.map((i) => (
                    <option key={i?.id} value={i?.id}>
                      {i?.name}
                    </option>
                  ))}
                </Form.Select>
            </Col>

        <Col md={2}>
          <Form.Label>{t("payment_method")}</Form.Label>
          <Form.Select
            onChange={(e) => setPayment(e?.target?.value)}
            size="md">
            <option value="">--{t("select_option")}--</option>
            <option value="CASH">{t("cash_money_name")}</option>
            <option value="TRANSFER">{t("transfer_money_name")}</option>
          </Form.Select>
        </Col>
        <Col md={2}>
          <Form.Label>{t("status")}</Form.Label>
          <Form.Select
            onChange={(e) => setSelectStatus(e?.target?.value)}
            value={selectStatus}
            size="md">
            <option value="">--{t("select_option")}--</option>
            <option value="COMPLETED">{convertOrderStatus("COMPLETED")}</option>
            <option value="INDEBTED">{convertOrderStatus("INDEBTED")}</option>
          </Form.Select>
        </Col>

            <Col sm style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Form.Label>{t("day_month_year")}</Form.Label>

              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
              >
                {(loadingSaleOrder && !orderGroupsData) ? (
                  <Spinner size="sm" />
                ) : (
                  <MdOutlineDateRange style={{ fontSize: 24 }} />
                )}
                &nbsp;  &nbsp;
                {!filter ? (
                  "mm/dd/yyyy"
                ) : (
                  <>
                    {covertTimeZone(filter?.createdAt_gte) +
                      " - " +
                      covertTimeZone(filter?.createdAt_lt)}
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </div>

        <div
          style={{
            margin: width > 700 ? "1em 2em" : 3,
            backgroundColor: "#fff",
            borderRadius: "5px",
          }}>
          {loadingSaleOrder && !orderGroupsData?.orderGroups ? (
            <div style={{ height: '70vh' }}>
              <AnimationLoading />
            </div>
          ) : (
            <>
              {ordergroup?.length > 0 ? (
                <Table
                  responsive
                  hover
                  style={{
                    // marginTop: "-1em",
                    borderCollapse: "collapse",
                    width: "100% ",
                    cursor: 'pointer'
                  }}>
                  <thead
                    style={{
                      background: LINEAR_GRADIENT_BG,
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      <th>#</th>
                      <th><small>{t("number_no")}</small></th>
                      <th><small>{t("customer_name")}</small></th>
                      <th><small>{t("customer_type")}</small></th>
                      <th><small>{t("category_name_tb")}</small></th>
                      <th><small>{t("phone_number")}</small></th>
                      <th><small>{t("qty_name_tb")}</small></th>
                      <th><small>{t("total_price_tb")}</small></th>
                      <th><small>{t("payment_method")}</small></th>
                      <th><small>{t("status")}</small></th>
                      <th><small>{t("day_month_year")}</small></th>
                      <th style={{ textAlign: 'center', minWidth: 100 }}><small>{t("all_order")}</small></th>
                      <th style={{ textAlign: 'right' }}><small>
                        {["DELETE_HISTORY_BILL"].some(permission => rolePermissions.includes(permission)) && t("action_tb")}
                      </small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordergroup
                      ?.filter((item) => {
                        if (selectStatus === "") return item.status !== "INDEBTED";
                        return item.status === selectStatus;
                      })
                      .map((item, index) => (

                        <tr
                          key={index}
                          className="saleRows"
                          onClick={() =>
                            handleCheck(item)
                          }>
                          <td>{index + 1 + _limit * (_skip - 1)}</td>
                          <td>{item?.code ?? ""}</td>
                          <td><Badge bg="light" text="dark">{item?.customerName ?? "-"}</Badge></td>
                          <td><Badge bg="light" text="dark">{item?.userConfirm?.userType?.name ?? "-"}</Badge></td>
                          <td><Badge bg="light" text="dark">{item?.orders && item?.orders?.length > 0
                              ? (!_.isEmpty(Array.from(new Set(item?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', '))
                                ? Array.from(new Set(item?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', ')
                                : Array.from(new Set(item?.orders.map(order => order?.stock?.categoryName).filter(Boolean))).join(', '))
                              : '-'}</Badge>
                          </td>
                          <td><Badge bg="light" text="dark">{item?.phone ?? "-"}</Badge></td>
                          <td><Badge bg="light" text="dark">{item?.amount ?? ""}</Badge></td>
                          <td style={{ minWidth: 100 }}>
                            {convertCurrency(item?.currency) ?? ""}{" "}
                            {numberFormat(item?.sumPrice) ?? ""}
                          </td>
                          <td>
                            <Badge bg="light" text="dark">{item.payment === "CASH"
                              ? t("cash_money_name")
                              : t("transfer_money_name")}</Badge>
                          </td>
                          <td
                            style={{
                              fontWeight: "bold"
                            }}>
                            <Badge bg={item?.status === "COMPLETED" ? "success" : item?.status === "CANCELLED" ? "danger" : item?.status === "WAITINGCONFIRM" ?  "warning" : "secondary"}>
                              {convertOrderStatus(item?.status) ?? ""}
                            </Badge>
                          </td>
                          <td>
                            <Badge bg="light" text="dark">{covertTimeZone(item?.createdAt)}</Badge>
                          </td>
                          <td>
                            <div>
                              <Table>
                                <tbody>
                                  {item?.orders.map((e, indx) => (
                                    <tr key={indx}>
                                      <td style={{ padding: 0 }}>
                                        <Badge bg="light" text="dark">{indx + 1}.</Badge>
                                      </td>
                                      <td style={{ padding: 0 }}>
                                        <Badge bg="light" text="dark">{e?.productName}</Badge>
                                      </td>
                                      <td style={{ padding: 0 }}>
                                        <Badge bg="light" text="dark"> ( {e?.amount} )</Badge>
                                      </td>
                                      <td style={{ padding: 0 }}>
                                        <Badge bg="light" text="dark">
                                        {(() => {
                                          const basePrice = Number(e?.price || 0);
                                          const optionsPrice = (e?.options?.length > 0 
                                            ? e?.options.reduce((sum, p) => sum + (Number(p?.price) || 0), 0)
                                            : 0
                                          ) // * (Number(e?.amount) || 1);
                                          
                                          const totalPrice = basePrice + optionsPrice;
                                          
                                          return `${numberFormat(totalPrice)} ${e?.currency || ''}`;
                                        })()}
                                      </Badge>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </td>
                          {["DELETE_HISTORY_BILL"].some(permission => rolePermissions.includes(permission)) && <td align="right" onClick={(e) => e.stopPropagation()}>
                            <CustomButton
                              width={40}
                              borderRadius="8px"
                              background="#dc2626"
                              color="#fff"
                              icon={
                                <DeleteIcon sx={{ color: "#fff", fontSize: 18 }} />
                              }
                              onClick={() =>
                                handleShowDelete(item?.id, item?.code)
                              }
                            />
                          </td>}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {ordergroup?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີປະຫວັດການຂາຍ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        {ordergroupToltal > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: '1em 2em'
            }}>
            {(ordergroupToltal && width > 700) && (
              <div className="show">
                ກຳລັງສະແດງ {50 * _skip - 49}-
                {50 * _skip > ordergroupToltal ? ordergroupToltal : 50 * _skip}{" "}
                ຈາກ {ordergroupToltal}
              </div>
            )}
            <div>{Pagination_helper(ordergroupToltal, "", ``)}</div>

          </div>
        ) : (
          ""
        )}
      </div>

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={_confirmeDelete}
        title="ແຈ້ງເຕືອນ"
        text={`ທ່ານຕອ້ງການລົບຂໍ້ມູນ ${Delete?.code} ນີ້ເເທ້ບໍ່!`}
        loadingConfirm={deleteloading}
      />
      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </React.Fragment>
  );
}
